
import { useEffect, useState } from 'react';
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const [particles, setParticles] = useState<Array<{ id: number; x: number; y: number; delay: number }>>([]);

  useEffect(() => {
    const newParticles = Array.from({ length: 50 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      delay: Math.random() * 5
    }));
    setParticles(newParticles);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=futuristic%20digital%20technology%20background%20with%20LED%20lights%2C%20artificial%20intelligence%20visualization%2C%20modern%20tech%20cityscape%20with%20blue%20and%20purple%20neon%20lights%2C%20high-tech%20digital%20interface%2C%20clean%20minimalist%20design%2C%20corporate%20technology%20atmosphere&width=1920&height=1080&seq=hero-bg&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-blue-900/50 to-purple-900/50"></div>
      
      {/* Partículas animadas */}
      <div className="absolute inset-0">
        {particles.map((particle) => (
          <div
            key={particle.id}
            className="absolute w-1 h-1 bg-blue-400 rounded-full opacity-60"
            style={{
              left: `${particle.x}%`,
              top: `${particle.y}%`,
              animation: `float 6s ease-in-out infinite ${particle.delay}s`
            }}
          ></div>
        ))}
      </div>

      <div className="relative z-10 container mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Logo grande clicável */}
          <div className="mb-8">
            <img 
              src="https://xperformancedigital.com.br/wp-content/uploads/2025/10/logo-branca.png" 
              alt="See Media - Mídia Inteligente" 
              className="h-64 md:h-80 w-auto object-contain mx-auto cursor-pointer transform hover:scale-105 transition-transform duration-300"
              onClick={scrollToTop}
              onError={(e) => {
                console.log('Erro ao carregar logo hero:', e);
                e.currentTarget.style.display = 'none';
              }}
              onLoad={() => console.log('Logo hero carregado com sucesso')}
            />
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              Redefinindo
            </span>
            <br />
            a Mídia Inteligente
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
            O futuro da comunicação visual impulsionado por Inteligência Artificial.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              onClick={() => scrollToSection('sobre')}
              variant="primary"
              size="lg"
              className="transform hover:scale-105"
            >
              <i className="ri-rocket-line mr-2"></i>
              Conheça nossas soluções
            </Button>
            
            <Button 
              onClick={() => scrollToSection('tecnologia')}
              variant="outline"
              size="lg"
              className="transform hover:scale-105"
            >
              <i className="ri-play-circle-line mr-2"></i>
              Como Funciona
            </Button>
          </div>
        </div>
      </div>

      {/* Indicador de scroll */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl opacity-70"></i>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }
      `}</style>
    </section>
  );
}
